const API_BASE_PATH = 'https://api.stillfy.com/api/';
const WS_BASE_PATH = 'https://api.stillfy.com';
const BASE_PATH = 'https://api.stillfy.com';
// const API_BASE_PATH = 'https://app.reallang.com/api/';
// const WS_BASE_PATH = 'https://app.reallang.com';
// const BASE_PATH = 'https://app.reallang.com';

const NOTIFICATION_DURATION = 7000; // ms

const TOKEN_EXPIRATION_PERIOD = 10; // days

// eslint-disable-next-line no-useless-escape
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const ACCEPT_FILE_TYPE =
  'image/png, image/jpeg, image/gif, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document';

export {
  API_BASE_PATH,
  WS_BASE_PATH,
  BASE_PATH,
  NOTIFICATION_DURATION,
  TOKEN_EXPIRATION_PERIOD,
  EMAIL_REGEX,
  ACCEPT_FILE_TYPE
};
